// extracted by mini-css-extract-plugin
export var typingIndicator = "_rw-0";